module.exports = "/subscriptions/assets/5f350a9d1067e17125630f4eb7e3ce4d.png";